import { useState, useEffect } from 'react';

const PLANS_CACHE_KEY = 'subscription_plans_cache';
const CACHE_EXPIRY_TIME = 60 * 60 * 1000; // 1 hora

export const useSubscriptionPlans = (user) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const customSuscription = user?.attributes?.profile?.privateData?.customSuscription;

  useEffect(() => {

    const cachedData = sessionStorage.getItem(PLANS_CACHE_KEY);
    if (cachedData) {
      try {
        const parsedData = null;//JSON.parse(cachedData);
        
        const isNotExpired = (Date.now() - parsedData.timestamp) < CACHE_EXPIRY_TIME;
        
        if (isNotExpired && parsedData.plans) {
          //console.log('📦 Usando planes desde cache');
          setPlans(parsedData.plans);
          return; 
        } else {
          //console.log('⏰ Cache expirado, eliminando...');
          sessionStorage.removeItem(PLANS_CACHE_KEY);
        }
      } catch (e) {
        //console.error('Error parsing cached plans:', e);
        sessionStorage.removeItem(PLANS_CACHE_KEY);
      }
    }

    const fetchPlans = async () => {
      setLoading(true);
      setError(null);
      
      try {

        const customMonthlyPlan = customSuscription?.monthly;
        const custumAnnualPlan = customSuscription?.annual;

        console.log("🍎🍎🍎 customMonthlyPlan:", customMonthlyPlan);
        console.log("🍎🍎🍎 customAnnualPlan:", custumAnnualPlan);

        const baseUrl = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/subscription-plans`;
        const params = new URLSearchParams();

        if (customMonthlyPlan?.planId) {
          params.append('customMonthlyPlan', customMonthlyPlan.planId);
        }

        if (custumAnnualPlan?.planId) {
          params.append('customAnnualPlan', custumAnnualPlan.planId);
        }

        const response = await fetch(
          `${baseUrl}${params.toString() ? `?${params.toString()}` : ''}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        //console.log("data", data)
        if (data.success) {
          setPlans(data.plans);
          const cacheData = {
            plans: data.plans,
            timestamp: Date.now()
          };
          sessionStorage.setItem(PLANS_CACHE_KEY, JSON.stringify(cacheData));
        } else {
          setError(data.error);
        }
      } catch (err) {
        //console.error('Error fetching plans:', err);
        setError('Error al cargar planes: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const clearCache = () => {
    sessionStorage.removeItem(PLANS_CACHE_KEY);
  };

  const refreshPlans = async () => {
    clearCache();
    window.location.reload();
  };

  return { plans, loading, error, clearCache };
};